import React, {useEffect, useState} from "react";
import FailedModal from "../../../../../CustomModal/Failed";
import Loader from "../../../../../../Loader/Loader";
import DashboardMenu from "../../../../../layout/dashboardMenu";
import Header from "../../../../../layout/header";
import useLatLng from "../../../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import DistanceCalculator from "../../../../../DistanceCalculator/Calculator";
import SuccessModal from "../../../../../CustomModal/Success";
import useSiteDistance from "../../../../../../hooks/currentlocation/useSiteDistance";

const CompleteUCDLeadActivity = ({
                                        documentUploadUrlPublic,
                                        documentUrlDataPublic,
                                        history,
                                        match,
                                        markAttendancesDealerLead,
                                        markAttendanceDetails = [],
                                        activityTypesDetails = [],
                                        activityTypes,
                                        newActivityDealerLead,
                                        NewActivityDetails = [],
                                        getActivityDetails = [],
                                        userCheckoutDealerLead,
                                        isCheckoutDetails = [],
                                        getActivityDealerLead,
                                        addedTaggedAlong = [],
                                        getLeadById,
                                        leadById = [],
                                     getActivityById,
                                     leadActivityById = []
                                    }) => {
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0);
    const [inputList, setInputList] = useState([
        {
            meta_data: {},
            lat: "",
            long: "",
            activity_type_id: "",
            activity_date: "",
            attendance_id: "",
            module_type: "",
            next_activity_date: "",
            next_activity_type_id: "",
        },
    ]);
    const [openCheckIn, setOpenCheckIn] = useState(false);
    const [checkInText, setCheckInText] = useState("");
    const [distance, setDistance] = useState();
    const [currentDate, setCurrentDate] = useState(
        now.toISOString().slice(0, 16)
    );
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [showSelfie, setShowSelfie] = useState(true);
    const [hideCheckIn, setHideCheckIn] = useState(false);

    let siteDistance = useSiteDistance(
        leadById?.data?.latitude,
        leadById?.data?.longitude
    )

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getActivityDealerLead(match?.params?.lead_id, false);
            await activityTypes('is_ucd');
            await getActivityById(match?.params?.id);
            await userCheckoutDealerLead(match?.params?.lead_id, "UCD");
            await getLeadById(match?.params?.lead_id);
            setIsLoading(false);
        })();
    }, []);



    useEffect(() => {
        // after check in hide popup
        if (
            markAttendanceDetails?.data !== undefined &&
            markAttendanceDetails?.status === 200
        ) {
            toast.success("Attendance is marked successfully");
            window.location.href = `ucd-lead-activity-list/${match?.params?.lead_id}`;
        } else if (
            markAttendanceDetails?.data !== undefined &&
            markAttendanceDetails?.status !== 200
        ) {
            toast.warning(markAttendanceDetails?.message);
        }
    }, [markAttendanceDetails]);

    useEffect(() => {
        //  if activity is completed then check is either check out or not, if not then open check out popup
        if (isCheckoutDetails?.data !== undefined && getActivityDetails?.data !== undefined) {
            if(parseInt(leadActivityById?.data?.status) === 1 && !isCheckoutDetails?.data?.check_in_lat){
                setCheckInText("Check in")
                setOpenCheckIn(true)
            }

            // if user already  marked check in so hide attendance pop up
            if(isCheckoutDetails?.data?.check_in_lat && !isCheckoutDetails?.data?.check_out_lat){
                setOpenCheckIn(false)
            }

            // if meeting is done but check  out is left
            if(parseInt(leadActivityById?.data?.status) === 2 && !isCheckoutDetails?.data?.check_out_lat){
                setCheckInText("Check out")
                setOpenCheckIn(true)
            }
        } else {
            // window.location.href = `dealer-activity-list/${match?.params?.id}`
        }
    }, [isCheckoutDetails, leadActivityById]);


    useEffect(() => {
        setHideCheckIn(false)
        if (leadById?.data !== undefined && leadById?.data?.longitude !== undefined) {
            let distance = '';
            if (siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN') {
                distance = siteDistance?.distance_in_km * 1000;
            }
            if (distance > 300 && checkInText === "Check In") {
                setHideCheckIn(true)
            }
            setDistance(parseFloat(distance).toFixed(2) + " meter away from site")
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)

        }
    }, [leadById, siteDistance])

    const handleSubmit = async (e) => {
        e.preventDefault();
        let list = inputList[0];
        list["activity_type_id"] = 49;
        list["activity_date"] = currentDate;
        if (list["activity_date"] === "") {
            toast.error("Please choose activity date");
            return false;
        }

        list['lead_id'] = match?.params?.lead_id;
        list['id'] = leadActivityById?.data?.id;
        list['module_type'] = 'UCD';
        list['lat'] = siteDistance?.curr_lat ?? islatlng?.lat
        list['long'] = siteDistance?.curr_long ?? islatlng?.lng

        if (list["long"] == null || list["lat"] == null) {
            toast.error("Please enable your location");
            return false;
        }

        // if(list['meta_data']['MOM'] !== undefined && list['meta_data']['MOM'].split("").length < 150){
        //   toast.warning("Mom must be minimum 150 characters")
        //   return false
        // }

        if (list?.meta_data?.MOM !== undefined && list?.meta_data?.MOM.length < 70) {
            toast.warning("MOM must be minimum 70 characters");
            return false;
        }


        // console.log("listlistlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true);
        await newActivityDealerLead(list);
        setIsLoading(false);
    };

    const handleInput = (key, val, metaKey, e, i = 0) => {
        let list = [...inputList];
        if (key === "meta_data") {
            inputList[0][key][metaKey] = val;
        } else {
            inputList[0][key] = val;
        }
        setInputList(list);
    };

    useEffect(() => {
        // show check out after complete activity
        if (
            NewActivityDetails?.data !== undefined &&
            NewActivityDetails?.status === 200
        ) {
            setOpenCheckIn(true);
            setHideCheckIn(false);
            setCheckInText("Check out");
            setShowSelfie(false);
            setMessage(NewActivityDetails?.message);
        } else if (
            NewActivityDetails?.data !== undefined &&
            NewActivityDetails?.status !== 200
        ) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsFailedModalOpen(true);
            setMessage(NewActivityDetails?.message);
        }
    }, [NewActivityDetails]);


    useEffect(() => {
        setIsFailedModalOpen(false);
        setIsSuccessModalOpen(false);
        if (addedTaggedAlong?.status === 200) {
            setIsSuccessModalOpen(true);
            setMessage(addedTaggedAlong?.message);
        } else if (
            addedTaggedAlong?.status !== undefined &&
            addedTaggedAlong?.status !== 200
        ) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsFailedModalOpen(true);
            setMessage(addedTaggedAlong?.message);
        }
    }, [addedTaggedAlong]);

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={message}
                url={`ucd-lead-activity-list/${match?.params?.id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={"Activity"} history={history}/>
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ? (
                                <div className="popup-box">
                                    <div className="box">
                                        <DistanceCalculator
                                            calculateDistance={markAttendancesDealerLead}
                                            moduleType={"UCD"}
                                            checkInText={checkInText}
                                            checkoutId={0}
                                            moduleId={match?.params?.id}
                                            activityId={
                                                leadActivityById?.data?.id !== undefined
                                                    ? leadActivityById?.data?.id
                                                    : ""
                                            }
                                            documentUrlDataPublic={documentUrlDataPublic}
                                            documentUploadUrlPublic={documentUploadUrlPublic}
                                            showSelfie={true}
                                            hideCheckButton={hideCheckIn}
                                            distance={distance}
                                            lat={leadById?.data?.latitude}
                                            long={leadById?.data?.longitude}
                                            leadId={match?.params?.lead_id}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100">
                                                        {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                        <span style={{color: "green"}}>
                                                                    {distance}
                                                                </span>
                                                    </h1>
                                                </div>
                                                {/*<div className="mb-0 bg-white">*/}
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_type_id', e.target.value, e)
                                                                    }}
                                                                    disabled={true}
                                                                >
                                                                    <option value="">Select Activity</option>
                                                                    {activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {parseInt(leadActivityById?.data?.activity_type_id) === val?.id ?

                                                                                    <option
                                                                                        value={val?.id}
                                                                                        selected={true}>{val.name}
                                                                                    </option> :
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Schedule Activity
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    onChange={(e) => {
                                                                        handleInput(
                                                                            "activity_date",
                                                                            e.target.value,
                                                                            e
                                                                        );
                                                                        setCurrentDate(e.target.value);
                                                                    }}
                                                                    id="validationCustom01"
                                                                    // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                                    max={
                                                                        new Date().toISOString().split("T")[0] +
                                                                        "T00:00"
                                                                    }
                                                                    value={currentDate}
                                                                    disabled={true}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder="MOM"
                                                                onChange={(e) => handleInput("meta_data", e.target.value, "MOM", e)}
                                                                required
                                                                id="validationCustom01"
                                                                rows="4"
                                                                cols="50"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*</div>*/}
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button
                                                        className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompleteUCDLeadActivity;
